/**
 * Vuex actions for the editor module.
 *
 * @module store/modules/editor/actions
 */
import { RootState } from "@/store/types";
import { ActionTree } from "vuex/types";
import _ from "lodash";
import { worker } from "@/bootstrap";
import { WorkerEvent } from "@/workers";

const actions: ActionTree<any, RootState> = {
  /**
   * Analyzes and retrieves all nodes connected to a given node.
   * Uses web worker for performance to analyze connections across content nodes,
   * triggers, intents, and API mappings.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {string} nodeId - ID of node to analyze
   * @returns {Promise<void>}
   *
   * @example
   * this.$store.dispatch('GET_CONNECTED_NODES', 'greeting_node');
   */
  GET_CONNECTED_NODES: async ({ rootState, commit }, nodeId) => {
    worker.postMessage({
      type: WorkerEvent.GET_CONNECTED_NODES,
      payload: {
        nodeId,
        nodes: _.get(rootState, "nodes") || {},
        intents: _.get(rootState, "training.dataset") || [],
        apiMappings: Object.values(_.get(rootState, "apieditor.mappings") || {}),
      },
    });
  },
};

export default actions;
